// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question {\n  display: flex;\n}\n\n.question span {\n  white-space: pre-wrap;\n}\n\n.gray-question-background {\n  background-color: #f2f3f3;\n}", ""]);
// Exports
module.exports = exports;
